var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "bottom-link__item" },
    [
      _c("h4", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _vm._l(_vm.links, function(item, index) {
        return _c("li", { key: index }, [
          _c("a", { attrs: { href: item.href } }, [_vm._v(_vm._s(item.text))])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0878d64c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878d64c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom/comp-link-item.vue
// module id = vsHZ
// module chunks = 1 2